import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/prop-types */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { Overlay } from './overlay';
import './overlay.scss';
export const OverlayContext = React.createContext(null);
const withOverlay = function (Node, settings = {
    backdropColor: 'rgba(0,0,0,0.5)',
    disableAnimation: false,
    disableBackdrop: false,
    hideDocumentOverflow: false,
    name: '',
}) {
    const Component = React.forwardRef((props, ref) => {
        const classPrefix = useRef('overlay');
        const overlayRef = useRef(null);
        const { showClose, onClose, onOpen, containedToParent, placementReference, placement, overlayAnimation, align, data, placementOffset, leftOffset,
        // name
         } = props;
        const { backdropColor, disableBackdrop, disableAnimation, hideDocumentOverflow, name, } = settings;
        const [portalWrapperCreated, setPortalWrapperCreated] = useState(false);
        const [isClosing, setIsClosing] = useState(false);
        const portalContainer = useRef(null);
        const [childInvokedClose, setChildInvokedClose] = useState(false);
        useEffect(() => {
            if (containedToParent?.current) {
                portalContainer.current = containedToParent.current;
                portalContainer.current.style.position = 'relative';
                setPortalWrapperCreated(true);
            }
            else {
                overlayRef.current = document.createElement('div');
                overlayRef.current.className = `${classPrefix.current}-portal-wrapper`;
                document.body.appendChild(overlayRef.current);
                portalContainer.current = overlayRef.current;
                setPortalWrapperCreated(true);
                return () => {
                    document.body.removeChild(overlayRef.current);
                };
            }
        }, []);
        const handleClose = useCallback(() => {
            setIsClosing(true);
            if (!disableAnimation) {
                setTimeout(() => {
                    setPortalWrapperCreated(false);
                    onClose && onClose();
                }, 250);
            }
            else {
                setPortalWrapperCreated(false);
                onClose && onClose();
            }
        }, []);
        const handleChildClose = useCallback(() => setChildInvokedClose(true), []);
        return portalWrapperCreated
            ? ReactDOM.createPortal(_jsx(OverlayContext.Provider, { value: {
                    align,
                    childClosing: childInvokedClose,
                    data,
                }, children: _jsx(Overlay, { showCloseButton: showClose, onClose: handleClose, onOpen: onOpen, placement: placement, placementReference: placementReference, backdropColor: backdropColor, containedToParent: !!containedToParent, overlayAnimation: overlayAnimation, disableBackdrop: disableBackdrop, hideDocumentOverflow: hideDocumentOverflow, placementOffset: placementOffset, leftOffset: leftOffset, name: name, children: _jsx(Node, { ...props, onClose: handleChildClose, isClosing: isClosing, ref: ref }) }) }), portalContainer.current)
            : null;
    });
    Component.displayName = `withOverlay`;
    return Component;
};
export { withOverlay };
